import { Input } from "@/components/ui/input";

interface CostInputProps {
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  className?: string;
}

export function CostInput({
  value,
  onChange,
  placeholder = "Enter cost",
  className = "",
}: CostInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const newValue = inputValue === "" ? null : Math.max(0, parseFloat(inputValue));
    if (!isNaN(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <Input
      type="number"
      min="0"
      value={value ?? ""}
      onChange={handleChange}
      placeholder={placeholder}
      className={`w-full ${className}`}
      aria-label="Cost Input"
    />
  );
}
